<template>
  <div class="body">
    <div class="boximg">
      <img src="../assets/img/icon_fail.png" alt>
    </div>
    <h3>签到失败</h3>
    <div class="bgc">
      <p class="p">当前会议已关闭，</p>
      <p class="pp">当前会议签到已关闭，请联系势银商务：0574-8781-8408</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: {},
      URL: ""      
    };
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.content = JSON.parse(localStorage.getItem("content"));
      this.URL = sessionStorage.getItem("URL");
      this.wxShare(
        this.content.title,
        this.content.description,
        this.content.thumbApp,
        this.URL
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.body {
  //   background: #fff;
  //   min-height: 100vh;
  //   box-sizing: border-box;
  // //   position: relative;
  // //   overflow: auto;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.bgc {
  text-align: left;
  margin-left: 18px;
  width: 340px;
  height: 147px;
  background: url("../assets/img/fail_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .p {
    padding-top: 27px;
    margin-left: 33px;
    margin-right: 33px;
  }
  .pp {
    margin-left: 33px;
    margin-right: 33px;
  }
}
h3 {
  font-size: 17px;
  color: #373737;
  margin-bottom: 39px;
}
.boximg {
  margin-top: 121px;
  margin-left: 147px;
  margin-bottom: 20px;
  width: 83px;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/signinfail.vue